import { all, put, call, take, takeLatest } from "redux-saga/effects"

import Echo from "laravel-echo"
import Pusher from "pusher-js"
import { eventChannel } from "redux-saga"
import axios from "axios"
import { push } from "connected-react-router"
import {
  UPDATE_BADGE,
  FETCH_NOTIFICATIONS,
  GO_TO_NOTIFICATION,
  SET_ALL_READ,
} from "./constants"
import {
  updateBadge,
  fetchNotificationsSuccess,
  fetchNotificationsFailed,
  GoToNotificationSuccess,
  setAllReadSuccess,
} from "./actions"
import { LOCAL_TOKEN, LOCAL_USER_ID } from "../../utils/storage"

const setAllReadApi = () =>
  axios.request({
    method: "get",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${
      process.env.API_URL
    }users/${LOCAL_USER_ID()}/notifications/bells/mark`,
  })

function* setAllReadSaga() {
  const result = yield call(setAllReadApi)
  if (result.status == 200) {
    yield put(setAllReadSuccess())
  }
}

const notificationReadApi = (id) =>
  axios.request({
    method: "get",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${
      process.env.API_URL
    }users/${LOCAL_USER_ID()}/notifications/bells/${id}/visited`,
  })

function* setNotificationVisitedSaga(action) {
  const result = yield call(notificationReadApi, action.payload.id)
  yield put(GoToNotificationSuccess(result.data.data[0]))
  // yield put(push(action.payload.link));
}

function getNotificationsApi(page) {
  return axios.request({
    method: "get",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    params: { per_page: page * 8 },
    url: `${process.env.API_URL}users/${LOCAL_USER_ID()}/notifications/bells`,
    validateStatus: (status) => true,
  })
}

function* getNotificationsSaga(action) {
  try {
    const result = yield call(getNotificationsApi, action.payload)
    const payload = {
      notifications: result.data.data,
      total: result.data.meta.total,
    }

    switch (result.status) {
      case 200:
        yield put(fetchNotificationsSuccess(payload))
        yield put(updateBadge(result.data.meta.total_unread))
        break
      case 422:
        yield put(fetchNotificationsFailed())
        break
      default:
        break
    }
  } catch (error) {}
}
function websoketInitChannel() {
  return eventChannel((emitter) => {
    const options = {
      broadcaster: "pusher",
      forceTLS: true,
      key: process.env.PUSHER_KEY,
      authEndpoint: `${process.env.API_URL}api/broadcasting/auth`,
      host: "http://localhost:2001",
      auth: {
        headers: {
          Authorization: `Bearer ${LOCAL_TOKEN()}`,
          Accept: "application/json",
        },
      },
    }

    const echo = new Echo(options)

    echo.private(`App.User.${LOCAL_USER_ID()}`).notification((data) => {
      return emitter(updateBadge(data.data.notifications_bells_unread))
    })

    return () => {
      echo.leave(`App.User.${LOCAL_USER_ID()}`)
    }
  })
}

export function* notificationWebsocketSaga() {
  const channel = yield call(websoketInitChannel)
  while (true) {
    const action = yield take(channel)
    yield put(action)
    yield put({ type: FETCH_NOTIFICATIONS, payload: 1 })
  }
}

// Individual exports for testing
export default function* notificationContainerSaga() {
  yield all([
    yield takeLatest(FETCH_NOTIFICATIONS, getNotificationsSaga),
    yield takeLatest(GO_TO_NOTIFICATION, setNotificationVisitedSaga),
    yield takeLatest(SET_ALL_READ, setAllReadSaga),
    yield call(notificationWebsocketSaga),
  ])
  // See example in containers/HomePage/saga.js
}
